export const mapClassData = (data) => {
  const {
    id: centerTiming,
    time_duration_text,
    date_text,
    session_title,
    description: session_description,
    center_id,
    has_user_booked,
    has_all_slots_booked,
    thumbnail: sessionThumbnail,
    meta,
    booking_id,
    is_event_ended,
    event_ended_message,
    all_slots_booked_message,
    shyft_pass_logo,
    is_waitlist_enabled,
    is_waitlist_joined,
  } = data;

  const {
    id: centerId,
    description,
    address,
    short_address,
    thumbnail,
    google_maps_link,
    name,
  } = center_id || {};

  const {
    class_details,
    attributes_list,
    attire,
    level,
    parking,
    email_text,
    base_price: price = 499,
    monthly_price = 1499,
  } = meta || {};

  const _level = attributes_list?.find(
    (a) => a?.title?.toLowerCase() === "level"
  );
  const _parking = attributes_list?.find(
    (a) => a?.title?.toLowerCase() === "parking"
  );
  const _attire = attributes_list?.find(
    (a) => a?.title?.toLowerCase() === "attire"
  );

  return {
    time: time_duration_text,
    date: date_text,
    title: session_title,
    description: session_description || email_text || description,
    location: address,
    shortLocation: short_address,
    googleMapLink: google_maps_link,
    thumbnail: sessionThumbnail || thumbnail,
    centerName: name,
    classDetail: {
      difficultyLevel: _level?.value || level?.text || "-",
      difficultyLevelColor:
        _level?.value_color || level?.text_color || "#282828",
      hasParking: _parking?.value || parking?.text || "-",
      hasParkingColor:
        _parking?.value_color || parking?.text_color || "#282828",
      attire: _attire?.value || attire?.text || "-",
      attireColor: _attire?.value_color || attire?.text_color || "#282828",
      classDetails: class_details || "",
      slotBookedStatus: has_user_booked,
      hasAllSlotsBooked: has_all_slots_booked,
      bookingId: booking_id,
    },
    centerId,
    centerTiming,
    price,
    isEventEnded: is_event_ended,
    eventEndedMessage: event_ended_message,
    allSlotsBookedMessage: all_slots_booked_message,
    shyftPassLogo: shyft_pass_logo,
    isWaitListEnabled: is_waitlist_enabled,
    isWaitListJoined: is_waitlist_joined,
    monthlyPrice: monthly_price,
  };
};

export const mapClassList = (res) =>
  res?.center_timings?.map((data) => mapClassData(data));

const mapWorkoutScheduleData = (data) => {
  const workoutScheduleData = {};

  const { center_details, event_dates } = data;

  workoutScheduleData.eventDates = event_dates?.map(
    ({ is_selected, tab_text, date }) => ({
      isSelected: is_selected,
      title: tab_text,
      date,
    })
  );

  workoutScheduleData.centerDetails = center_details?.map((data) =>
    mapClassData(data)
  );

  return workoutScheduleData;
};

export default mapWorkoutScheduleData;
